import React from "react";
import PicMD from "../PicMD";
import LoadingIndicator from "./Loading";

const Palak = () => {
  return (
    <div>
      <PicMD doctor="Palak" />
      <strong>Meet APRN Palak Patel</strong>
      <br />
      <br />
      <p><LoadingIndicator /></p>
      <br />
      <br />
      <br />
      <br />
      <br />
    </div>
  );
};

export default Palak;
